module.exports = __webpack_public_path__ + "img/menu-listen.f8e98bec.png";